import set from 'lodash/set';
import state from 'store/state/definitions';
import types from 'store/types/definitions';

const initialState = state;

export default (state = initialState, action) => {
  const { key, data } = action;

  switch (action.type) {
    case types.DEFINITIONS_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
